import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import legacyEventHub from '~/modules/legacyRuntime.js';

class TrackListingSortInputs extends Component {
  constructor(props) {
    super(props);

    this.handleSelectChange = this.handleSelectChange.bind(this);

    this.state = {
      sortBy: this.props.sortBy,
      sortDirection: this.props.sortDirection
    }
  }

  handleSelectChange(event) {
    let [sortBy, sortDirection] = event.target.value.split(':');
    let stateObject = { sortBy: sortBy, sortDirection: sortDirection };

    legacyEventHub.trigger('changeSort', stateObject);
    this.setState(stateObject);
  }

  render() {
    let classes = ['sort-inputs', this.props.className].filter(Boolean).join(' ');
    let currentSortValue = this.state.sortBy + ':' + this.state.sortDirection;

    return (
      <div className={classes}>
        <div className='sort-inputs__select-layout'>
          <label className='sort-inputs__select-label' htmlFor={this.props.selectId}>
            {this.props.locale === 'de' ? 'Sortierung:' : 'Sort:'}
          </label>
          <div className='sort-inputs__select-field'>
            <select
              id={this.props.selectId}
              className='sort-inputs__select'
              value={currentSortValue}
              onChange={this.handleSelectChange}
            >
              <option value='popularity:desc'>{this.props.locale === 'de' ? 'Beliebtheit' : 'popularity'}</option>
              <option value='length:desc'>{this.props.locale === 'de' ? 'Dauer (absteigend)' : 'duration (longest first)'}</option>
              <option value='length:asc'>{this.props.locale === 'de' ? 'Dauer (aufsteigend)' : 'duration (shortest first)'}</option>
              <option value='date:desc'>{this.props.locale === 'de' ? 'Neueste' : 'most recent'}</option>
            </select>
          </div>
        </div>
      </div>
    )
  }
};

TrackListingSortInputs.defaultProps = {
  sortBy: 'popularity',
  sortDirection: 'desc',
  className: '',
  selectId: 'track-listing-sort'
}

TrackListingSortInputs.propTypes = {
  locale: PropTypes.string
};

// INIT

let elements = document.querySelectorAll('[data-react-component=TrackListingSortInputs]');

elements.forEach(function(element) {
  let reactProps = JSON.parse(element.dataset.reactProps);

  ReactDOM.render(
    <React.StrictMode>
      <TrackListingSortInputs {...reactProps} />
    </React.StrictMode>,
    element
  );
})


export default TrackListingSortInputs;
